/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

/* See app/services/data_deletion_service/models/conversation_deletion_schedule.rb for state values */
enum State {
  Active = 'active',
  Paused = 'paused',
}

export default class ConversationDeletionSchedule extends Model {
  @attr('number') declare retentionDays: number;
  @attr('string') declare state: string;

  get isActive() {
    return this.state === State.Active;
  }
}
